__turbopack_context__.v({
  "code-component": "code-component-module-scss-module__aTd8Qq__code-component",
});
